import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { PageHeader, Menu, Dropdown, Button, Tag, Space, Col, Row, Card  } from 'antd';
import { EllipsisOutlined, DownloadOutlined } from '@ant-design/icons';
import {getLessonplans} from '../actions/lessonplan';
import {getNotes} from '../actions/note';
import {getStudentreports} from '../actions/studentreport';
import { useLocation } from 'react-router-dom';

const Reports = (props) => {

    const  locs = useLocation();
    const { note, subjectname, termname, themename } = locs.state
    const {title, note:notes, instruction} = note

    const DropdownMenu = () => (
        <Dropdown key="more" >
          <Button>
            <EllipsisOutlined
              style={{
                fontSize: 20,
                verticalAlign: 'top',
              }} 
            /> Select
          </Button>
        </Dropdown>
    );


    return (
        <div>
            <PageHeader
                title={subjectname}
                className="site-page-header no-print"
                subTitle={termname}
                tags={<Tag color="blue">Active</Tag>}
                extra={[
                    <DropdownMenu key="more" />,
                ]}
                avatar={{ src: 'https://avatars1.githubusercontent.com/u/8186664?s=460&v=4' }}    
            ></PageHeader>
           
            <Card style={{textAlign:'left'}}>
                <h2>{title}</h2>
            <div  dangerouslySetInnerHTML={{__html: instruction}} />

            <div  dangerouslySetInnerHTML={{__html: notes}} />
                
            </Card>
            
        </div>
    )
}

const mapStateToProps = (state) => ({
    lessonplans:state.lessonplanReducer,
    notes:state.noteReducer,
    reports:state.reportReducer.reports,
    schools:state.reportReducer.schools,
    claszs:state.reportReducer.claszs,
    studentreport:state.studentreportReducer.studentreports,
    mid:state.userReducer.mid
})

const mapDispatchToProps = {
    getStudentreports,
    getLessonplans,
    getNotes
}

export default connect(mapStateToProps, mapDispatchToProps)(Reports)
